import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FormControl, FormGroup} from "@angular/forms";
import {SharedDataService} from "../../../services/shared-data.service";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-service-config-popup',
  templateUrl: './service-config-popup.component.html',
  styleUrls: ['./service-config-popup.component.css']
})
export class ServiceConfigPopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();

  public componentForm: FormGroup = new FormGroup({});
  packages: object[];
  packageGroups: string[] = [];
  packagesGrouped: object[][] = [];
  state: string = 'default';
  mode: string;
  errMsg: string = '';

  constructor(public sharedDataService: SharedDataService,
              public dialog: MatDialog,
              public confirmationDialog: MatDialog) { }

  ngOnInit(): void {
  }

  public addFormControls(): void {
  }

  public onNoClick(): void {
    this.close.emit()
  }

}
